import { render, staticRenderFns } from "./Blacklists.vue?vue&type=template&id=d22aefe0&scoped=true&"
import script from "./Blacklists.vue?vue&type=script&lang=js&"
export * from "./Blacklists.vue?vue&type=script&lang=js&"
import style0 from "./Blacklists.vue?vue&type=style&index=0&id=d22aefe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22aefe0",
  null
  
)

export default component.exports